import { AuthToken } from "Helpers/AuthToken";
import RedirectHelper from "Helpers/RedirectHelper";

export default class ApiService {
  static getPlants(): Promise<any> {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/plant`, {
      headers: AuthToken(),
    })
      .then((response) => {
        RedirectHelper(response);
        return response.json();
      })
      .catch((error) => console.error(error.message));
  }

  static getPlant(id: string): Promise<any> {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/plant/${id}`, {
      headers: AuthToken(),
    })
      .then((response) => {
        RedirectHelper(response);
        return response.json();
      })
      .catch((error) => console.error(error.message));
  }

  static getPlantings(ids: string[]): Promise<any> {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/planting/ids`, {
      method: "POST",
      headers: AuthToken(),
      body: JSON.stringify({ ids }),
    })
      .then((response) => {
        RedirectHelper(response);
        return response.json();
      })
      .catch((error) => console.error(error.message));
  }

  static createPlanting(inBody: string): Promise<any> {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/planting/`, {
      headers: AuthToken(),
      body: inBody,
      method: "POST",
    })
      .then((response) => {
        RedirectHelper(response);
        return response.json();
      })
      .catch((error) => console.error(error.message));
  }

  static savePlantingIds(germinationTray: any): Promise<any> {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/germinationTray`, {
      method: "PUT",
      body: JSON.stringify(germinationTray),
      headers: AuthToken(),
    })
      .then((response) => {
        RedirectHelper(response);
        console.log(response);
        return response.status;
      })
      .catch((e) => console.error(e));
  }

  static updatePlanting(inBody: string): Promise<any> {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/planting/`, {
      headers: AuthToken(),
      body: inBody,
      method: "PUT",
    })
      .then((response) => {
        RedirectHelper(response);
        return response;
      })
      .catch((error) => console.error(error.message));
  }

  static deletePlanting = (id: string): Promise<any> => {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/planting/${id}`, {
      method: "DELETE",
      headers: AuthToken(),
    })
      .then((response) => {
        RedirectHelper(response);
        return response.status;
      })
      .catch((e) => console.error(e));
  };

  static createPlant(inBody: string): Promise<any> {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/plant/`, {
      headers: AuthToken(),
      body: inBody,
      method: "POST",
    })
      .then((response) => {
        RedirectHelper(response);
        return response.json();
      })
      .catch((error) => console.error(error.message));
  }

  static updatePlant(inBody: string): Promise<any> {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/plant/`, {
      headers: AuthToken(),
      body: inBody,
      method: "PUT",
    })
      .then((response) => {
        RedirectHelper(response);
        return response.json();
      })
      .catch((error) => console.error(error.message));
  }

  static deletePlant = (id: string): Promise<any> => {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/plant/${id}`, {
      method: "DELETE",
      headers: AuthToken(),
    })
      .then((response) => {
        RedirectHelper(response);
        return response;
      })
      .catch((e) => console.error(e));
  };

  static deletePlantsById = (ids: string[]): Promise<any> => {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/plant/delete`, {
      method: "POST",
      body: JSON.stringify({ ids }),
      headers: AuthToken(),
    })
      .then((response) => {
        RedirectHelper(response);
        return response;
      })
      .catch((e) => console.error(e));
  };

  static getPlantsByName = (name: string): Promise<any> => {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/plant/name`, {
      body: JSON.stringify({ name: name }),
      method: "POST",
      headers: AuthToken(),
    })
      .then((response) => {
        RedirectHelper(response);
        return response.json();
      })
      .catch((error) => console.error(error.message));
  };

  static deleteGerminationTray = (id: string): Promise<any> => {
    return fetch(
      `${process.env.REACT_APP_API_URL ?? ""}/api/germinationTray/${id}`,
      {
        method: "DELETE",
        headers: AuthToken(),
      },
    )
      .then((response) => {
        RedirectHelper(response);
        return response.json();
      })
      .catch((e) => console.error(e));
  };

  static getGerminationTray = (id: string): Promise<any> => {
    return fetch(
      `${process.env.REACT_APP_API_URL ?? ""}/api/germinationTray/${id}`,
      {
        headers: AuthToken(),
      },
    )
      .then((response) => {
        RedirectHelper(response);
        return response.json();
      })
      .catch((error) => console.error(error.message));
  };

  static createGerminationTray = (body: any): Promise<any> => {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/germinationTray`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: AuthToken(),
    })
      .then((response) => {
        RedirectHelper(response);
        return response.json();
      })
      .catch((error) => console.error(error));
  };

  static getTraysByName = (name: string): Promise<any> => {
    return fetch(
      `${process.env.REACT_APP_API_URL ?? ""}/api/germinationTray/name`,
      {
        body: JSON.stringify({ name: name }),
        method: "POST",
        headers: AuthToken(),
      },
    )
      .then((response) => {
        RedirectHelper(response);
        return response.json();
      })
      .catch((error) => console.error(error.message));
  };

  static getGerminationTrays = (): Promise<any> => {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/germinationTray`, {
      headers: AuthToken(),
    })
      .then((response) => {
        RedirectHelper(response);
        return response.json();
      })
      .catch((error) => console.error(error));
  };

  static getVarieties = (): Promise<any> => {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/variety`, {
      headers: AuthToken(),
    })
      .then((response) => {
        RedirectHelper(response);
        return response.json();
      })
      .catch((error) => console.error(error));
  };

  static createVariety = (body: any): Promise<any> => {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/variety`, {
      method: "POST",
      body: JSON.stringify(body),
      headers: AuthToken(),
    })
      .then((response) => {
        RedirectHelper(response);
        return response.json();
      })
      .catch((error) => console.error(error));
  };

  static updateVariety = (body: any): Promise<any> => {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/variety`, {
      method: "PUT",
      body: JSON.stringify(body),
      headers: AuthToken(),
    })
      .then((response) => {
        RedirectHelper(response);
        return response.json();
      })
      .catch((error) => console.error(error));
  };

  static deleteVariety = (id: string): Promise<any> => {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/variety/${id}`, {
      method: "DELETE",
      headers: AuthToken(),
    })
      .then((response) => {
        RedirectHelper(response);
        return response.json();
      })
      .catch((error) => console.error(error));
  };

  static login = (usernameOrEmail: string, password: string): Promise<any> => {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/Auth/login`, {
      method: "POST",
      body: JSON.stringify({
        usernameOrEmail,
        password,
      }),
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((data) => {
        return data.json();
      })
      .catch((error) => console.error(error));
  };

  static register = (
    email: string,
    username: string,
    password: string,
  ): Promise<any> => {
    return fetch(`${process.env.REACT_APP_API_URL ?? ""}/api/Auth/register`, {
      method: "POST",
      body: JSON.stringify({
        email,
        username,
        password,
      }),
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((data) => {
        return data.json();
      })
      .catch((error) => {
        console.error(error);
        console.log(error);
      });
  };

  static googleSignIn = (accessToken: string): Promise<any> => {
    return fetch(
      `${process.env.REACT_APP_API_URL ?? ""}/api/Auth/google-signin`,
      {
        method: "POST",
        body: JSON.stringify({ access_token: accessToken }),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
        },
      },
    )
      .then((response) => response.json())
      .catch((error) => console.error(error));
  };
}
